import { render } from "./BzdBg.vue?vue&type=template&id=5859c9eb"
import script from "./BzdBg.vue?vue&type=script&lang=js"
export * from "./BzdBg.vue?vue&type=script&lang=js"

import "./BzdBg.vue?vue&type=style&index=0&id=5859c9eb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__